import { useAuth } from '../lib/auth-context';
import { useState, useEffect } from 'react';

interface SplitViewProps {
  children: (tenantId?: string) => React.ReactNode;
}

export function SplitView({ children }: SplitViewProps) {
  const { allTenants, activeTenantId, switchTenant } = useAuth();
  const [selectedTenantId, setSelectedTenantId] = useState(activeTenantId);

  // Update selected tenant when active tenant changes
  useEffect(() => {
    setSelectedTenantId(activeTenantId);
  }, [activeTenantId]);

  // If only one tenant, just show the content
  if (allTenants.length <= 1) {
    return <>{children(activeTenantId)}</>;
  }

  // Multiple tenants: show tabs
  return (
    <div className="flex flex-col h-full">
      {/* Tenant Tabs */}
      <div className="border-b border-sg-border bg-sg-dark/50">
        <div className="flex gap-1 px-6">
          {allTenants.map((tenant) => (
            <button
              key={tenant.id}
              onClick={() => {
                setSelectedTenantId(tenant.id);
                switchTenant(tenant.id);
              }}
              className={`px-4 py-3 text-sm font-medium transition-colors relative ${
                selectedTenantId === tenant.id
                  ? 'text-sg-accent border-b-2 border-sg-accent'
                  : 'text-gray-400 hover:text-gray-300'
              }`}
            >
              {tenant.label}
              {selectedTenantId === tenant.id && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-sg-accent" />
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto">
        {children(selectedTenantId)}
      </div>
    </div>
  );
}
